/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum SpecialQuestion {
    COMPLIANCE_ITEM_ACTION_DATE = 'ComplianceItemActionDate',
    UPDATE_WORKFLOW_NAME = 'UpdateWorkflowName',
    MULTI_RESPONSE_SHORTCODE = 'MultiResponseShortcode',
    SAVE_TO_TABLE = 'SaveToTable',
    GET_FROM_TABLE = 'GetFromTable',
    NONE = 'None',
    NEEDS_ASSESSMENT_SCORE = 'Needs_Assessment_Score',
    COPY_TO_HOUSING_APPLICATION = 'Copy_To_Housing_Application',
    COPY_TO_FINDER_INPUTS = 'Copy_To_Finder_Inputs',
    UPDATE_HOUSING_APPLICATION_TO_OFFER_ACTIVE = 'Update_Housing_Application_To_Offer_Active',
    OFFER_DECISION = 'Offer_Decision',
    SAVE_TO_HOUSING_APPLICATION_LOG = 'Save_To_Housing_Application_Log',
    CANCELLATION_FORM = 'Cancellation_Form',
    NO_OFFER_FORM = 'No_Offer_Form',
    MOVE_BACK_TO_REVIEW = 'Move_Back_To_Review',
    UPDATE_APPLICATION_EARLIEST_OCCUPANCY_DATE = 'Update_Application_Earliest_Occupancy_Date',
}
